export const STRING = {
  //LOGIN PAGE
  LOGIN_TITAL: "Welcome Back",
  LOGIN_DESC: "Enter your email and password to Sign in",
  REGISTER_DESC: "Sign up with ",
  LOGIN_EMALI: "Email Address",
  LOGIN_PASSWORD: "Password",
  REGISTER_USERNAME: "Username",
  REGISTER_USERNAME_PLACEHOLDER: "Enter User name",
  REGISTER_USERNAME_REQUIRED: "Usename is required",
  REGISTER_USERNAME_FORMATE: "Usename must be at least 3 characters",
  LOGIN_BUTTON: "Login",
  LOGIN_EMAIL_PLACEHOLDER: "Enter Email Address",
  LOGIN_PASSWORD_PLACEHOLDER: "Enter Password",
  LOGIN_EMAIL_REQUIRED: "Email Address is required",
  LOGIN_PASSWORD_REQUIRED: "Password is required",
  LOGIN_EMAIL_FORMAT: "Enter valid email Address",
  LOGIN_PASSWORD_FORMAT: "Password must be at least 6 characters",
  LOGOUT: "Logout",
  REGISTER_LABEL: "Don't have an account?",
  SIGN_UP: "Sign up",
  LOGIN_LABEL: "Already have an account?",
  SIGN_IN: "Sign in",
  SUBMIT: "submit",
  FORGATEPASSWORD_LABEL: "Forgot Password?",
  FORGATEPASSWORD_DEC: "Enter your Email here...",
  RESET_PASSWORD: "Reset Password",
  RESET_PASSWORD_DEC: "Your password must be 6 digits long",
  RESET_NEW_PASSWORD: "New Password",
  RESET_CONFIRM_PASSWORD: "Confirm Password",
  RESET_NEW_PLACEHOLDER: "Enter new Password",
  RESET_CONFIRM_PLACEHOLDER: "Enter confirm Password",
  RESET_NEW_REQUIRED: "New Password is required",
  RESET_CONFIRM_REQUIRED: "Confirm Password is required",
  RESET_NEW_FORMAT: "New Password must be at least 6 characters",
  RESET_CONFIRM_FORMAT: "Confirm Password must be at least 6 characters",
  RESET_MATCH_FORMATE: "Password and ConfirmPassword do not match",
  EMAIL_VERFIY_MESSAGE:
    "Please verify your account in mail with Invitation link",
  LUXCHONO: "Luxchono",
  REGISTER_PHONNO: "phone Number",
  REGISTER_PHONNO_PLACEHOLDER: "Enter Phon Number",
  REGISTER_PHONNO_REQUIRED: "Phon Number is required",
  FORGOT_PASSWORD_LINK: "Forgot password?",
  INVALID_NUMBER: "Invalid phone number",
  PAASWORD_STORANGE:
    "Password must contain at least one digit, one lowercase character, and one uppercase character. Minimum length is 8 characters",
  USER_NAME_STORANGE:
    "Username must be 3-8 characters, alphanumeric, with at least 2 letters",
  FULL_NAME: "Full name must contain at least 6 characters",
  ADDRESS_FORMAT: "Address must contain at least 20 characters",
  CITY_FORMAT: "City Name must be at least 2 characters long",
  PIN_FORMAT: "Pincode must be at least 6 characters long",

  NOW_GOTO_LOGIN: "Now go to Login",
  CHECK_MAIL_BOX: "Check your mail",
  //Dialog
  DIALOG_CANCEL_BUTTON: "Cancel",
  DIALOG_YES_BUTTON: "Yes",
  DIALOG_TITAL: "Confirm Logout",
  DIALOG_DESC: "Are you sure you want to Logout?",

  // product
  PRODUCT_NODATA_AVAILABLE: "No data available",
  PRODUCT_SEARCH_PLACHOLDER: "Search Product",

  //delete dilog
  DELETE_SURE: "Are You Sure? ",
  PRODUCT_DELETE_DESC: "You want to Delete Selected Products?",
  DELETE_CLOSE_BUTTON: "No, Keep It",
  DELETE_YES_BUTTON: "Yes, Delete It",

  //category
  CATEGORYADD: "Add Category",
  CATEGORY_SEARCH_PLACHOLDER: "Search Category",
  CATEGORY_NAME: "Category Name :-",
  CATEGORY_IMAGE: "Image :-",
  ICON: "Icon :-",
  CATEGORY_NAME_REQUIRED: "Name is required",
  CATEGORY_NAME_FORMAT: "Category must be at least 3 characters",
  CATEGORY_NAME_IMAGE: "Image is required",
  CATEGORY_ICON_REQUIRED: "Icon is required",
  CATEGORY_DELETE_DESC: "You want to Delete Selected Category?",
  CATEGORYEDIT: "Edit Category",
  CATEGORY_NAME_PLACHOLDER: "Enter Category Name",
  EXPORT_BUTTON: "Export",

  //Brand
  BRANDADD: "Add Brand",
  BRAND_SEARCH_PLACHOLDER: "Search Brand",
  BARND_NAME: "Brand Name:-",
  BARND_IMAGE: "Image :-",
  BRAND_NAME_REQUIRED: "Name is required",
  BRAND_NAME_FORMAT: "Brand must be at least 3 characters",
  BRAND_NAME_IMAGE: "Image is required",
  BRAND_ICON_REQUIRED: "Icon is required",
  BRAND_DELETE_DESC: "You want to Delete Selected Brand?",
  BRANDEDIT: "Edit Category",
  BRAND_NAME_PLACHOLDER: "Enter Brand Name",
  IMAGE_TYPE: "Upload only Image",
  DELETE_BUTTON: "Delete",
  IMAGE_FORMATES: "Image Upload only .png , .svg , .jpg and .jpeg formate only",

  //product add page
  PRODUCT_ADD: "Add Product",
  PRODUCT_IMAGE: "Product Image :-",
  PRODUCT_THUMBNAIL: "Thumbnail :-",
  PRODUCT_NAME: "Product Name :-",
  PRODUCT_DESC: "Product Description :-",
  PRODUCT_STOCK: "Product Stock :-",
  PRODUCT_CATEGORY: "Category :-",
  PRODUCT_BRAND: "Brand :-",
  PRODUCT_PRICE: "Product Price :-",
  PRODUCT_MODEL: "Product Model :-",
  PRODUCT_WARRANTY: "Product Warranty :-",
  PRODUCT_DUMMY_PRICE: "Product Dummy Price :-",
  PRODUCT_IMAGE_REQUIRED: "Image is required",
  PRODUCT_CATEGORY_REQUIRED: "Category is required",
  PRODUCT_NAME_REQUIRED: "Name is required",
  PRODUCT_DESC_REQUIRED: "Description is required",
  PRODUCT_STOCK_REQUIRED: "Stock is required",
  PRODUCT_BRAND_REQUIRED: "Brand  is required",
  PRODUCT_PRICE_REQUIRED: "Price  is required",
  PRODUCT_MODEL_REQUIRED: "Model is required",
  PRODUCT_WARRANTY__REQUIRED: "Warranty is required",
  PRODUCT_DUMMYPRICE__REQUIRED: "Dummy Price is required",
  PRODUCT_THUMNAIL_REQUIRED: "Thumbnail is required",
  PRODUCT_NAME_PLACHOLDER: "Enter Product Name",
  PRODUCT_DESC_PLACHOLDER: "Enter Product Description",
  PRODUCT_STOCK_PLACHOLDER: "Enter Product Stock",
  PRODUCT_CATEGORY_PLACHOLDER: "Select Category",
  PRODUCT_BRAND_PLACHOLDER: "Select Brand",
  PRODUCT_PRICE_PLACHOLDER: "Enter Product Price",
  PRODUCT_MODEL_PLACHOLDER: "Enter Product Model",
  PRODUCT_WARRANTY_PLACHOLDER: "Enter Product Warranty",
  PRODUCT_DUMMYPRICE_PLACHOLDER: "Enter Product Dummy Price",
  PRODUCT_NAME_FORMAT: "Product name must be at least 3 characters",
  PRODUCT_THUMNAIL_FORMAT: "You can only upload photo in PNG format",
  PRODUCT_MAXIMU_IMAGE: "Upload maximu 4 images",
  PRODUCT_EDIT: "Edit Product",
  //order
  ORDER__SEARCH_PLACHOLDER: "Search Order",
  ORDER_DELETE_DESC: "You want to Delete Selected Order?",
  ORDER_VIEW: "View Order",
  ORDER_ID: "Order ID :-",
  ORDER_CUSTOMER_NAME: "Customer name :-",
  ORDER_CREATE_ON: "Create on :-",
  ORDER_METHOD: "Method :-",
  ORDER_AMOUNT: "Amount :-",
  ORDER_STATUS: "Status :-",
  ORDER_QTY: "Product Qty :-",
  ORDER_PRODUCT_NAME: "Product name :-",
  ORDER_ADDRESS: "Shipping Address :-",
  ORDER_NUMBER: "Mobile number :-",
  ORDER_IMAGE: "Image :-",

  //offer
  ADD_OFFER: "Add Offer",
  OFFER_IMAGE: "image :-",
  OFFER_NAME: "Offer Name :-",
  OFFER_DATE: "Select Date :-",
  OFFER_BRANDS: "Brands :-",
  OFFER_PRODUCT: "Products :-",
  OFFER_CODE: "Offer Code :-",
  OFFER_DISCOUNT: "Discount :-",
  OFFER_DISCOUNT_TYPE: "Discount Type :-",
  OFFER_DESCRIPTION: "Description :-",
  SAVE: "Save",
  OFFER_NAME_PLACHOLDER: "Enter Offer Name",
  OFFER_PRODUCTS_PLACHOLDER: "Select Products",
  OFFER_BRANDS_PLACHOLDER: "Select Brands",
  OFFER_OFFERCODE_PLACHOLDER: "Enter Offer Code",
  OFFER_DISCOUNT_PLACHOLDER: "Enter Discount",
  OFFER_DISCOUNTTYPE_PLACHOLDER: "Select Discount Type",
  OFFER_DESCRIPTION_PLACHOLDER: "Enter Description",
  OFFER_OFFERNAME_REQUIRED: "Name is required",
  OFFER_OFFERNAME_FORMATE: "Offer Name must be at least 3 characters",
  OFFER_DISCOUNTTYPE_REQUIRED: "Discount Type is required",
  OFFER_OFFERCODE_REQUIRED: "Code is required",
  OFFER_DISOUNT_REQUIRED: "Discount is required",
  OFFER_BRANDS_REQUIRED: "Product Brand is required",
  OFFER_PRODUCTS_REQUIRED: "Product is required",
  OFFER_IMAGE_REQUIRED: "Image is required",
  OFFER_DISCOUNT_REQUIRED: "Discount Date is required",
  OFFER_DELETE_DESC: "You want to Delete Selected Offer?",
  OFFER_EDIT: "Edit Offer",
  OFFER_VIEW: "View Offer",

  //product filter grawer
  ADVANCED_SEARCH: "Advanced Search",
  PRICE: "Price range",
  TO: "To",
  STOCK: "Stock range",
  RESET: "Reset",
  APPLAY: "Apply",
};
